import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Flyout } from '@els/els-react--flyout';
import StructureModel from '@Components/Results/structure/structure-model.service';
import htmlStripsService from '@Services/HtmlStripsService';
import StructurePreview from '@Components/Results/structure/StructurePreview';
import StructureToolbarComponent from '@Components/Results/structure/structure-toolbar.component';
import InnerHTML from '@Components/InnerHTML';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import join from 'lodash/join';
import StructureContext from '@Components/Results/structure/StructureContext';

import './Structure.scss';

function getContextValue(props) {
  return {
    metadata: props.metadata,
    structure: props.structure,
  };
}

/* eslint-disable react/destructuring-assignment */
export default class Structure extends React.PureComponent {
  constructor(props) {
    super(props);
    this.previewProps = this.getPreviewProps();
    this.structureContextValue = getContextValue(props);
  }

  // useMemo when migrating to functional component
  componentDidUpdate(prevProps) {
    if (this.props.structure !== prevProps.structure) {
      this.structureContextValue = getContextValue(this.props);
    }
  }

  getPreviewProps() {
    let previewProps = {};
    const details = get(this.props, 'structure.details');

    if (details) {
      previewProps = {
        mixtureName: details.mixtureItems ? details.type : null,
        structureId: details.id,
        title: htmlStripsService.getTitleWithoutHtml(details.linearFormula, 'full'),
      };
    }
    return previewProps;
  }

  render() {
    const { props } = this;
    const imagePath = get(props, 'structure.molImage.path');
    const chemicalNames = get(props, 'structure.details.chemicalNames');
    const modificationLabel = get(props, 'structure.details.modification');
    const structureName = get(props, 'structure.name');
    const showToolbar = props.showToolbar && !!get(this.props, 'structure.details');
    const className = classnames([props.className, 'substance-image-container']);

    return (
      <StructureContext.Provider value={this.structureContextValue}>
        <div className={className} aria-label={join(chemicalNames)}>
          <div className="substance-image-container-inner">
            {props.title && <div className="substance-image-container-title">{props.title}</div>}
            <StructurePreview
              zoom={props.zoom}
              previewPath={imagePath}
              {...this.previewProps}
              structureName={structureName}
              chemicalNames={chemicalNames}
            />
          </div>
          <div className="substance-toolbar-container">
            {!isEmpty(modificationLabel) && (
              <Flyout
                flyout={
                  <>
                    <div className="u-els-font-family-bold">Modification:</div>
                    <InnerHTML tag="div" className="modification-value" html={modificationLabel} />
                  </>
                }
                placement="top-end"
                theme="simple"
                trigger="hover"
                pointerType="primary">
                <div className="substance-modification__content u-els-max-width-10o10">
                  <InnerHTML tag="div" className="modification-value u-els-font-size-meta" html={modificationLabel} />
                </div>
              </Flyout>
            )}
            {showToolbar ? <StructureToolbarComponent spOptions={props.spOptions} /> : null}
          </div>
        </div>
      </StructureContext.Provider>
    );
  }
}

Structure.defaultProps = {
  showToolbar: true,
};

Structure.propTypes = {
  metadata: PropTypes.object.isRequired,
  structure: PropTypes.instanceOf(StructureModel).isRequired,
  title: PropTypes.string,
  zoom: PropTypes.number,
  spOptions: PropTypes.object,
  className: PropTypes.string,
  showToolbar: PropTypes.bool,
};
